import { createSelector } from '@reduxjs/toolkit'
import { State } from 'store'

export const getSnackbarMessages = createSelector(
    (state: State) => state.messages.messages,
    (messages) => messages.filter((message) => message.type !== 'inline'),
)
